import React from "react";
import styles from "./NavigationGuide.module.css";

const NavigationGuide = () => {
  return (
    <div className={styles.navigationGuide}>
      {/* <div className={styles.navigationGuideHeader}>Navigation Guide</div> */}
      <div className="card-header">
        <h2>Navigation Guide</h2>
      </div>
      <div className={styles.navigationGuideContent}>
        <div className={styles.navigationGuideList}>
          <div className={styles.navigationGuideListItem}>
            <div className={styles.navigationGuideListNumber}>1</div>
            <div className={styles.navigationGuideListContent}>
              <span className={styles.navigationGuideBold}>
                Check this page daily.
              </span>
              &nbsp;The most current information and clinical assignments will be
              posted here.
            </div>
          </div>
          <div className={styles.navigationGuideListItem}>
            <div className={styles.navigationGuideListNumber}>2</div>
            <div className={styles.navigationGuideListContent}>
              Review and complete every item listed under the requirements
              section.
            </div>
          </div>
          <div className={styles.navigationGuideListItem}>
            <div className={styles.navigationGuideListNumber}>3</div>
            <div className={styles.navigationGuideListContent}>
              Keep your contact information up to date in My Account.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationGuide;
